import {useState, useEffect} from "react";
import {Row, Container, Card} from "react-bootstrap";
import {useSelector, useDispatch} from "react-redux";
import ControlParty from "../components/ControlParty";
import GPCInformationProyect from "../components/rightInformation";
import {selectPc, GraficoPCG, ProjectDetailsPc} from "../actions/proyects.actions";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import { SelectedDateFn, selectedScaleFn } from "../actions/auth.action";
import { saveUserPreferences } from "../services/apiPreferences";

// import Proyeccion from "../components/Proyeccion";
// import JSONpretty from 'react-json-pretty';

const IdPc = ({match, codProyect, codClassification, codType, codPc: codPcParam, ...props}) => {
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector(state => state.auth);
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState({});
	const [titleCard, setTitleCard] = useState("");
	let codProject = match?.params.codProject || codProyect;
	let codPc = match?.params.codPc || codPcParam;
	let classification = match?.params.codClassification || codClassification;

	useEffect(() => {
		if (!codProject || !classification || !auth.dateSelected) {
			return
		}
		dispatch(selectPc(codProject, codPc, classification, auth.dateSelected, auth.scaleSelected));

		// eslint-disable-next-line
	}, [codProject, codPc, classification, auth.dateSelected]);

	useEffect(() => {
		setData(proyects.DataPc[0]);
		setLoading(false);
		// eslint-disable-next-line
	}, [proyects.DataPc[0]]);

	const handleDateChange = (date) =>{
		dispatch(SelectedDateFn(date))
		saveUserPreferences({
			scaleSelected: `${auth.scaleSelected}`,
			dateSelected: `${date}`,
		}).then(({data}) => {
			console.log('---- save preferences date response', data)
		}).catch(e => console.error(e))
	}

	const handleScaleChange = (scale) => {
		dispatch(SelectedDateFn(''))
		dispatch(selectedScaleFn(`${scale || 0}`))
		saveUserPreferences({
			scaleSelected: `${scale}`,
			dateSelected: '',
		}).then(({data}) => {
			console.log('---- save preferences scale response', data)
		}).catch(e => console.error(e))
	}

	const getClassificationInitials = (classification) => {
		switch (classification) {
			case 'pc':
				return 'PC'
			case 'de':
				return 'DE'
			case 'ft':
				return 'FT'
			default:
				return ''
		}
	}

	const finalTitleCard = loading 
							? 'cargando...'
							: !data
								? 'Sin información'
								: `RO - ${getClassificationInitials(classification)} 
								${titleCard ? ` (${titleCard}): ` : ': '} 
								${data.Descripcion}`

	return (
		<Container style={{width: '100%', maxWidth: '100%'}}>
			<Row>
				<Card className="w-100 mb-1 mt-2">
					<Card.Header className="bg-primary p-0 d-flex align-items-center justify-content-around mb-0">
						<Grid container direction="row" justifyContent="space-between" alignItems="center">
							<Grid item xs={8}>
								<h5 className="mb-0 ml-5" style={{maxWidth: '50%'}} >
									{finalTitleCard}
								</h5>
							</Grid>

							<Grid item xs={2}>
								<h5 className="mb-0 ml-1" style={{width: 120}}>
									<FormControl >
										<InputLabel shrink id="scales-label" style={{color: 'white'}}>
											Escala
										</InputLabel>
										<Select
											labelId="scales-label"
											id="scales"
											// value={scale}
											value={auth.scaleSelected !== '' ? auth.scaleSelected : localStorage.getItem('scale-project')}
											onChange={(event) => {
												handleScaleChange(event.target.value);
											}}
											displayEmpty
											fullWidth
											// className={classes.selectEmpty}
										>
											<MenuItem value="">
												<em>Por defecto</em>
											</MenuItem>
											<MenuItem value={'0'}>Mensual</MenuItem>
											<MenuItem value={'1'}>Semanal</MenuItem>
											<MenuItem value={'2'}>Anual</MenuItem>
										</Select>
									</FormControl>
									
								</h5>
							</Grid>
							<Grid item xs={2}>

								<div className="mb-0 ml-1 d-flex  align-items-center">

									<FormControl >
										<InputLabel shrink id="dates-label" style={{color: 'white'}}>
											Hasta
										</InputLabel>
										<Select
											labelId="dates-label"
											id="dates"
											value={auth.dateSelected ? auth.dateSelected : localStorage.getItem('date-project')}
											onChange={event => handleDateChange(event.target.value)}
											displayEmpty
											fullWidth
											// className={classes.selectEmpty}
										>
											<MenuItem value="">
												<em></em>
											</MenuItem>
											{proyects.dates.map((d, i) => (
												<MenuItem key={`${i}`} value={d.CodPeriodo}>{d.DesPeriodo}</MenuItem>
											))}
										</Select>
									</FormControl>
								</div>
							</Grid>
						</Grid>
					</Card.Header>
					<Card.Body className="p-1">
						<div className="d-flex justify-content-around">
							<Card.Text className="mb-1">
								Monto{" "}
								{Intl.NumberFormat("en").format(
									data?.MontoContrato || ''
								)}
							</Card.Text>

							<Card.Text className="mb-1">
								{data?.FechaInicio || ''}/{data?.FechaFinal || ''}
							</Card.Text>

							<Card.Text
								style={{fontSize: 12}}
								className="text-primary mb-2"
							>
								({data?.ReporteA || ''})
							</Card.Text>
						</div>

						<div className="d-flex justify-content-around">
							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-blue card-h5 mr-2 d-flex"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Programado
								</div>
								<p className="mb-1 text-right">
									{" "}
									{Intl.NumberFormat("en").format(
										data?.Programado || ''
									)}
								</p>
								<p className="mb-1 text-right">
									{" "}
									{data?.PorcentajeProgramado || ''}%
								</p>
							</div>

							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-yellow card-h5 mr-2 "
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Valorizado
								</div>
								<p
									className={`mb-1 text-right text-right ${
										data?.PorcentajeFA || '' < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{Intl.NumberFormat("en").format(
										data?.Valorizado || ''
									)}
								</p>
								<p
									className={`mb-1 text-right text-right ${
										data?.PorcentajeFA || '' < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{data?.PorcentajeValorizado || ''}%
								</p>
							</div>

							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-aqua card-h5 mr-2"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Real
								</div>
								<p
									className={`mb-1 text-right ${
										data?.PorcentajeFC || '' < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{Intl.NumberFormat("en").format(
										data?.Real || ''
									)}
								</p>
								<p
									className={`mb-1 text-right ${
										data?.PorcentajeFC || '' < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{data?.PorcentajeReal || ''}%
								</p>
							</div>

							<div>
								<h5 className="card-h5">Fa</h5>
								<p
									className={`mb-1 text-right ${
										data?.PorcentajeFA || '' < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{Intl.NumberFormat("en").format(
										data?.FA || ''
									)}
								</p>
								<p
									className={`mb-1 text-right ${
										data?.PorcentajeFA || '' < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{data?.PorcentajeFA || ''}%
								</p>
							</div>

							<div>
								<h5>Fc</h5>
								<p
									className={`mb-1 text-right ${
										data?.PorcentajeFC || '' < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{" "}
									{Intl.NumberFormat("en").format(
										data?.FC || ''
									)}
								</p>
								<p
									className={`mb-1 ${
										data?.PorcentajeFC || '' < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{data?.PorcentajeFC || ''}%
								</p>
							</div>
						</div>

						<div className="w-100">
							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-blue"
											style={{
												width: `${data?.PorcentajeProgramado || ''}%`,
											}}
										></div>
									</div>
								</div>

								<div  style={{width: '10%'}}>
									<b className="porcentaje-barra">
										{data?.PorcentajeProgramado || ''}%
									</b>
								</div>
							</div>

							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-yellow"
											style={{
												width: `${data?.PorcentajeValorizado || ''}%`,
											}}
										></div>
									</div>
								</div>

								<div style={{width: '10%'}}>
									<b className="porcentaje-barra">
										{" "}
										{data?.PorcentajeValorizado || ''}%
									</b>
								</div>
							</div>

							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-aqua"
											style={{
												width: `${data?.PorcentajeReal || ''}%`,
											}}
										></div>
									</div>
								</div>

								<div style={{width: '10%'}}>
									<b className="porcentaje-barra">
										{" "}
										{data?.PorcentajeReal || ''}%
									</b>
								</div>
							</div>
						</div>
					</Card.Body>
				</Card>
			</Row>

			{/* <JSONpretty data={proyects.treePartyControl} /> */}
			{(codType ?
				<GPCInformationProyect
					CodProyect={codProject}
					setTitleCard={setTitleCard}
					CodPc={codPc}
					classification={classification}
					graphicLinesRedux={() => dispatch(GraficoPCG(codProject, classification, codPc, 1))}
					graphicBarRedux={() => dispatch(GraficoPCG(codProject, classification, codPc, 0))}
					tableDetailsRedux={() => dispatch(ProjectDetailsPc(codProject, codPc, classification, auth.scaleSelected, auth.dateSelected))}
					// onClickGraphicLines={}
					// graphicLinesReduxWithHead
					// graphicBarReduxWithHead
				/>
			:
				<ControlParty
					CodProyect={codProject}
					setTitleCard={setTitleCard}
					CodPc={codPc}
					typeName={classification}
				/>
			)}
			
			
			{/* <Proyeccion /> */}
			{/* <hr />

			<h3 className="text-center mb-3">Liquidez</h3> */}
		</Container>
	);
};

export default IdPc;
